import React from "react";

// Aperçu d'un message WhatsApp (bulle de template) : image, texte, pied, boutons.
const css = `
.wa-phone{width:310px;border-radius:28px;background:#efeae2;padding:18px 14px;box-shadow:0 0 0 8px #111,0 20px 40px -20px rgba(0,0,0,.4);margin:8px auto}
.wa-bubble{background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 1px 1px rgba(0,0,0,.1);font-size:13.5px;line-height:1.4;white-space:pre-wrap}
.wa-bubble img{width:100%;height:160px;object-fit:contain;background:#f5f5f5;display:block}
.wa-bubble .wa-noimg{height:120px;display:grid;place-items:center;background:#f5f5f5;color:#999;font-size:12px}
.wa-bubble .b{padding:8px 10px 4px}.wa-bubble .h{padding:8px 10px 0;font-weight:700}.wa-bubble .f{padding:0 10px 6px;color:#8a8a8a;font-size:12px}
.wa-btn{border-top:1px solid #eee;text-align:center;color:#0a84c6;font-weight:600;padding:8px;font-size:13.5px}
`;

export function WhatsAppPreview({ header, headerText, imageURL, body, footer, buttons = [] }) {
    const image = header === "image" || header === "product_image";
    return (
        <div className="wa-phone">
            <style>{css}</style>
            <div className="wa-bubble">
                {image && (imageURL ? <img src={imageURL} alt="" /> : <div className="wa-noimg">{header === "product_image" ? "Photo du produit du contact" : "Image d'en-tête"}</div>)}
                {header === "text" && headerText && <div className="h">{headerText}</div>}
                <div className="b">{body || " "}</div>
                {footer && <div className="f">{footer}</div>}
                {buttons.map((b, i) => <div key={i} className="wa-btn">{b.kind === "optout" ? b.text : `↗ ${b.text}`}</div>)}
            </div>
        </div>
    );
}
